import Helmet from 'react-helmet';
import { useMessage } from '../i18n';

export interface PageTitleProps {
  title: string;
  subtitle?: string;
}

export const PageTitle = ({ title, subtitle = '' }: PageTitleProps) => {
  const formatMessage = useMessage();

  return (
    <Helmet>
      <title>{`${subtitle ? `${subtitle} | ` : ''}${title} | ${formatMessage('cloudinary')}`}</title>
    </Helmet>
  );
};
